<a class="btn btn-action btn-small btn-back back-navigation" [routerLink]="{ cxRoute: 'dispenserAgreements' } | cxUrl">
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.dispensers' | cxTranslate }}
</a>

<div class="row align-items-end">
  <div class="col-12 col-md form-group">
    <button class="btn btn-primary btn-small" (click)="downloadCSV()" [disabled]="disableWhenNoDataOrDownloading">
      <i [class]="downloadingCsv ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
      {{ 'shipmentCreditClaim.downloadCreditHistory' | cxTranslate }}
    </button>
  </div>
  <div class="col-12 col-sm-6 col-md form-group">
    <app-custom-search-input
      title="Search"
      placeholder="Search by Shipment ID or credit memo"
      (eventSearch)="SearchByMemoId($event)"
    ></app-custom-search-input>
  </div>
  <div class="col-12 col-sm-6 col-md form-group">
    <app-custom-search-input
      title="Search"
      placeholder="Agreement ID"
      (eventSearch)="SearchById($event)"
    ></app-custom-search-input>
  </div>
  <!-- <div class="col col-sm col-md-auto form-group"> -->
  @if (shipmentCreditClaims?.results?.length) {
    <div class="col col-sm-auto form-group">
      <app-custom-select
        [title]="'shared.sortBy' | cxTranslate"
        (changeValue)="sortChange($event)"
        [clearable]="true"
        [options]="options"
        [placeHolder]="'shared.select' | cxTranslate"
      ></app-custom-select>
    </div>
  }
</div>

@if (shipmentCreditClaims?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    override="ShipmentCreditClaimRow"
    rowId="id"
    [rows]="shipmentCreditClaims.results"
    [pagination]="shipmentCreditClaims.pagination"
    (changePagination)="pageChange($event + 1)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (!showLoaderOnPagination) {
    <app-custom-error
      [errorMessage]="'shipmentCreditClaim.CreditClaimcode' | cxTranslate"
    ></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
